// src/utils/currencyFormatter.js

/**
 * Formats reward amount with currency symbol
 * @param {number} amount - The reward amount
 * @param {string} currencySymbol - Currency symbol (defaults to '£')
 * @returns {string} Formatted currency string
 */
export const formatCurrency = (amount, currencySymbol = '£') => {
  if (amount === null || amount === undefined) {
    return `${currencySymbol}0.00`;
  }
  
  // Convert to number if it's a string
  const numericAmount = typeof amount === 'string' ? parseFloat(amount) : amount;
  
  // Format to 2 decimal places with currency symbol
  return `${currencySymbol}${numericAmount.toFixed(2)}`;
};

/**
 * Extracts currency symbol from task data or uses default
 * @param {object} task - Task object
 * @returns {string} Currency symbol
 */
export const getCurrencySymbol = (task) => {
  return task?.currency || '£'; // Default to Pound symbol
};